export class AssignationSalesView {
    id: number;
    status: number;
    assignationDate: Date;
    sales: AdministratorView | null;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.status = data?.status ?? 0
        this.assignationDate = data?.assignationDate ?? null
        this.sales = data?.sales ? new AdministratorView(data?.sales) : null;
    }
}

class AdministratorView {

    id: number;
    name: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.name = data?.name ?? ""
    }

}